import React, { useState, useRef } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Alert,
  CircularProgress,
  Button,
  TextField,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
} from "@mui/material";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useStateContext } from "../context/ContextProvider";
import axiosClient from "../axiosClient";
import { useNavigate } from 'react-router-dom';

export default function LoginScreen() {
  const { setToken } = useStateContext();
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const navigate = useNavigate();

  const handleToggleRePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const emailRef = useRef();
  const passwordRef = useRef();

  const handleLogin = () => {
    setLoading(true);
    const payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value
    };

    axiosClient
      .post(`auth/login/admin`,payload)
      .then((resp) => {
        setToken(resp.data.accessToken);
        setLoading(false);
        navigate("/customers", { state: { id: resp.data.admin.AdminGroupId, name: resp.data.admin.AdminGroup.name } })
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
        setErrorMessage("Wrong email or password!")}
      )
  };

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} sm={8} md={6}>
        <Card style={{ maxWidth: 400 }}>
          <CardContent>
            <Typography variant="h5" component="h2" align="center" gutterBottom>
              Login
            </Typography>
            {loading && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
              </Box>
            )}
            <Box sx={{ "& .MuiTextField-root": { width: "100%" } }}>
              <form>
                {errorMessage && (
                  <Alert severity="error" sx={{ marginBottom: 4 }}>
                    {errorMessage}
                  </Alert>
                )}
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Email"
                      variant="outlined"
                      fullWidth
                      inputRef={emailRef}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel htmlFor={`outlined-adornment-password`}>
                        Password
                      </InputLabel>
                      <OutlinedInput
                        id={`outlined-adornment-password`}
                        type={passwordVisibility ? "text" : "password"}
                        inputRef={passwordRef}
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleToggleRePasswordVisibility}
                              edge="end"
                            >
                              {passwordVisibility ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        }
                        label="Password"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      onClick={handleLogin}
                    >
                      Sign In
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
